import React from 'react'

function ContactsPage() {
  return (
    <main>
        <div className="main_section_1_img_wrapper">
            <img src={require("./static/img/taxi.jpg")} alt="" />
            <h2 className="blur_div">
                &nbsp;
                “MARYAWTOULAG” <br />
                ÖNÜMÇILIK BIRLEŞIGI
                <img src="./static/img/arrow_down.png" alt="" />
            </h2>
        </div>


        <div className="news_title_section">
            <h2>BIZ HAKDA</h2>
            <img src={require("./static/img/element2.png")} className="" alt="" />
        </div>

        <div className="contacts_section_3">
            <div className="contacts_section_3_inner_wrapper">
                <a className="section_3_column_1" href="tel:80052256575">
                    <img src={require("./static/img/icons/greenphone.png")} alt="" />
                    <span>80052256575</span>
                </a>
                <a className="section_3_column_2" href="mailto:maryavtoulag@sanly.tm">
                    <img src={require("./static/img/icons/greenemail.png")} alt="" />
                    <span>maryavtoulag@sanly.tm</span>
                </a>
                <a className="section_3_column_3" href="tel:80052256214">
                    <img src={require("./static/img/icons/greenfax.png")} alt="" />
                    <span>80052256214</span>
                </a>
            </div>
        </div>

        <div className="contacts_section_4">
            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d8940.087760614479!2d61.81951588574562!3d37.60690484209457!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3f418e5b476daabf%3A0x9225a0a5b7c8818c!2zw51lxYhpxZ9pxYggNTAgw715bGx5Z3kga8O2w6dlc2ksIE1hcnksIFR1cmttZW5pc3Rhbg!5e0!3m2!1sen!2s!4v1672073913618!5m2!1sen!2s" width="100%" height="100%" style={{border:'0'}} allowFullScreen="" loading="lazy" referrerPolicy="no-referrer-when-downgrade"></iframe>
        </div>
        
        <div className="contacts_section_5">
            <div className="contacts_section_5_inner_wrapper">
                <div className="section_5_img_wrapper">
                    <img src={require("./static/img/icons/location_yellow.png")} alt="" />
                </div>
                <span>Mary welaýaty, Mary şaheri, Ýeňişiň 50 ýyllygy köçesiniň 54-nji jaýy.</span>
            </div>
        </div>

    </main>

  )
}

export default ContactsPage